import { actionTypes } from '../actions/constants';

export default function footerReducer(state = {}, action) {

    switch (action.type) {
        case actionTypes.SET_CURRENCY:
            return {
                ...state,
                userCurrency: action.currency
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/footerReducer.js